<script setup lang="ts">
  import { ref } from 'vue'

  const model = defineModel<number>({ default: 0 })
  const props = withDefaults(defineProps<{ size?: number }>(), { size: 6 })
  const emit = defineEmits<{
    input: [value: number]
  }>()

  const hoverRating = ref<number>(0)

  const setRating = (value: number) => {
    model.value = value
    emit('input', value)
  }

  const isHovered = (star: number) => {
    return star <= hoverRating.value
  }

  const isActive = (star: number) => {
    return star <= model.value
  }
</script>

<template>
  <div class="flex flex-row">
    <button
      v-for="star in 5"
      :key="star"
      type="button"
      class="pr-1 transition-opacity duration-150"
      @mouseenter="hoverRating = star"
      @mouseleave="hoverRating = 0"
      @click="setRating(star)"
    >
      <i-fa7-solid-star
        class="cursor-pointer text-yellow-400"
        :class="
          `size-${size} ` +
          (isActive(star) ? 'opacity-100' : isHovered(star) ? 'opacity-50' : 'opacity-10')
        "
      />
    </button>
  </div>
</template>
